import isUndefined from "lodash/fp/isUndefined";
import { saveAs } from "file-saver";
class Controller {
  constructor($stateParams, Sections, $injector, GoogleMaps) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.Station = $injector.get("Station");
    this.Messages = $injector.get("Messages");
    this.StationTransforms = $injector.get("StationTransforms");

    this.City = $injector.get("City");
    this.sections = Sections.routesSections;
    this.googleMapsUrl = GoogleMaps.getSource();
    this.onUpdate = this.Events.getUpdateEvent("station");
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const setMapPosition = (station) => {
      this.mapPosition = [
        station.loc.coordinates.value.lat,
        station.loc.coordinates.value.lng,
      ];
    };
    const onUpdate = (item) => {
      const updatedItem = {};
      updatedItem[item.key] = isUndefined(item.value)
        ? item.name
          ? item.name._id
          : null
        : item.value;

      this.Station.updateAction(
        this.$stateParams.id,
        item.methodName,
        updatedItem
      ).$promise.then(
        (response) => {
          this.station = this.StationTransforms.justify(response);
          this.Events.emit(
            showNotificationEvent,
            this.Messages.updateMessage("station", item.key)
          );
          setMapPosition(this.station);
        },
        (response) => {
          if (response.data.routeIds) {
            const newRowRegex = "\r\n";
            const filteredData = response.data.routeIds.map((id) => {
              return {
                route_id: id,
              };
            });
            const columns =
              Object.keys(filteredData[0]).join(",") + newRowRegex;
            const rows = filteredData.reduce((rows, row) => {
              return rows.concat(Object.values(row).join(",") + newRowRegex);
            }, "");
            const parsedData = columns + rows;
            const csvFile = new File([parsedData], `Conflicting Routes.csv`);
            saveAs(csvFile);
          }
          this.Events.emit(errorEvent, response.data);
        }
      );
    };
    this.onMapInit = (map) => {
      this.map = map;
      this.marker = map.markers[0];
    };
    this.onMarkerClick = () => {
      this.map.setZoom(18);
      this.map.setCenter(this.marker.getPosition());
    };

    this.Station.get(this.$stateParams.id).$promise.then((response) => {
      this.station = this.StationTransforms.justify(response);
      this.City.get(response.city.value).$promise.then((response) => {
        this.districtEditable =
          response.feature_flags.stations_district_editing.enabled;
      });
      setMapPosition(this.station);
    });

    this.Events.on(this.onUpdate, onUpdate);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/station/station.controller.js